import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useEffect, useState } from 'react';

import { MediaDisplay } from './rightSectionComponents/media';
import { CarouselDots } from './rightSectionComponents/carouselDots';
import { CarouselItem } from './rightSectionComponents/carouselItem';

export type TCarouselItem = {
  id: number;
  type: 'video' | 'image';
  description: string;
  url: string;
};

const carouselItems: TCarouselItem[] = [
  {
    id: 1,
    type: 'video',
    description: 'Get started with our quick video tutorial',
    url: 'https://www.youtube.com/embed/RuQycZvK9Kk?si=vDi03jPBk-VLJP8-',
  },
  {
    id: 2,
    type: 'image',
    description: 'Explore the apps key features at a glance',
    url: '/images/sign-in-bg.jpg',
  },
  {
    id: 3,
    type: 'image',
    description: 'Discover tips to enhance your experience',
    url: '/images/sign-in-bg.jpg',
  },
  {
    id: 4,
    type: 'video',
    description: 'See the app in action and master the workflow',
    url: 'https://www.youtube.com/embed/Qq_EsKtvU9k?si=nI1TnsRr1O6oWRdu',
  },
];

const LoginRightSection: React.FC = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });
  const [selectedIndex, setSelectedIndex] = useState(0);

  const currentItem = carouselItems[selectedIndex];

  const updateCurrentItem = useCallback(() => {
    if (!emblaApi) return;
    const index = emblaApi.selectedScrollSnap();
    setSelectedIndex(index);
  }, [emblaApi]);

  const scrollTo = useCallback(
    (index: number) => {
      emblaApi?.scrollTo(index);
    },
    [emblaApi],
  );

  const handleWatchNow = useCallback(() => {
    if (currentItem.type !== 'video') return;

    const iframe = document.querySelector<HTMLIFrameElement>(
      `iframe[title="Video ${currentItem.id}"]`,
    );

    if (iframe) {
      const currentSrc = iframe.getAttribute('src')!;
      const newSrc = currentSrc.includes('?')
        ? `${currentSrc}&autoplay=1`
        : `${currentSrc}?autoplay=1`;
      iframe.setAttribute('src', newSrc);
    } else {
      window.open(currentItem.url, '_blank');
    }
  }, [currentItem]);

  useEffect(() => {
    if (!emblaApi) return;

    emblaApi.on('select', updateCurrentItem);
    updateCurrentItem();

    return () => {
      emblaApi.off('select', updateCurrentItem);
    };
  }, [emblaApi, updateCurrentItem]);

  return (
    <div className='grid h-screen place-content-center lg:px-56 px-5'>
      <div className='relative mb-10 h-[420px] w-full rounded-lg border-[11px] border-[rgba(255,255,255,0.09)]'>
        <MediaDisplay {...currentItem} />
      </div>

      <div className='w-full overflow-hidden'>
        <div
          ref={emblaRef}
          className='embla'
        >
          <div className='embla__container flex'>
            {carouselItems.map((item) => (
              <CarouselItem
                key={item.id}
                item={item}
                onWatchNow={handleWatchNow}
              />
            ))}
          </div>
        </div>
      </div>
      <div className='mt-8 flex justify-center'>
        <CarouselDots
          itemsLength={carouselItems.length}
          selectedIndex={selectedIndex}
          onClick={scrollTo}
        />
      </div>
    </div>
  );
};

export default LoginRightSection;
